export default __webpack_public_path__ + "static/media/o14.8c78a0af.jpg";